import { render } from "./vformclue.vue?vue&type=template&id=18dd0124&scoped=true"
import script from "./vformclue.vue?vue&type=script&lang=js"
export * from "./vformclue.vue?vue&type=script&lang=js"

import "./vformclue.vue?vue&type=style&index=0&id=18dd0124&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18dd0124"]])

export default __exports__